import { useEffect, useState } from 'react';
import { alertError } from '../../components/Toast';
import { fetchBrands, fetchModels } from '../utils/fipe';
import { isValidPlate, fetchVehicleByPlate } from '../utils/vehiclePlate';

const useVehicleForm = (initialValues = {}) => {
  const [values, setValues] = useState(initialValues);
  const [loadingPlate, setLoadingPlate] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  const onChange = ({ field, value }) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  };

  const createOption = ({ name, field }) => {
    setValues((prev) => ({
      ...prev,
      [field]: { label: name, value: '0' },
    }));
  };

  const changePlate = async ({ plate: oldPlate, skipIfSame }) => {
    const plate = oldPlate.toUpperCase();
    onChange({ field: 'plate', value: plate });

    if (skipIfSame && plate === skipIfSame) return;

    if (isValidPlate(plate)) {
      setLoadingPlate(true);
      try {
        const vehicleData = await fetchVehicleByPlate(plate);
        if (!vehicleData) {
          alertError(
            'Erro ao achar o veículo, por favor continue o cadastro manualmente.'
          );
          return;
        }
        setValues((prev) => ({ ...prev, ...vehicleData }));
      } catch {
        alertError(
          'Erro ao consultar a placa, por favor continue o cadastro manualmente.'
        );
      } finally {
        setLoadingPlate(false);
      }
    }
  };

  // Carrega marcas da FIPE
  const loadBrands = async () => {
    const brands = await fetchBrands();
    setBrandOptions(brands);
  };

  // Converte brand string para objeto {value, label} quando as opções carregam
  useEffect(() => {
    if (brandOptions.length > 0 && values?.brand && !values?.brand?.label) {
      const selectedBrand =
        brandOptions.find((brand) => brand.nome === values.brand) || {};
      setValues((old) => ({
        ...old,
        brand: {
          value: selectedBrand.codigo || old.brand,
          label: selectedBrand.nome || old.brand,
        },
      }));
    }
  }, [values?.brand, brandOptions]);

  // Converte model string para objeto {value, label} quando as opções carregam
  useEffect(() => {
    if (values?.brand?.label && values?.model && !values?.model?.label) {
      const selectedModel =
        modelOptions.find((model) => model.nome === values.model) || {};
      setValues((old) => ({
        ...old,
        model: {
          value: selectedModel?.codigo || old?.model,
          label: selectedModel?.nome || old?.model,
        },
      }));
    }
  }, [values?.model, values?.brand?.label, modelOptions]);

  // Carrega modelos quando a marca muda
  useEffect(() => {
    const brandValue = values?.brand?.value;
    if (!brandValue || brandValue === values?.brand?.label) return;

    const createdBrand = brandOptions.find(
      (item) => item.id === brandValue
    );
    if (!createdBrand) {
      fetchModels(brandValue).then(setModelOptions);
    }
  }, [values?.brand?.value]);

  return {
    values,
    setValues,
    loadingPlate,
    brandOptions,
    modelOptions,
    onChange,
    createOption,
    changePlate,
    loadBrands,
  };
};

export default useVehicleForm;
